<script>
import { Line } from 'vue-chartjs';

export default {
	extends: Line,
	name: 'chart-line',
	props: {
		chartdata: {
			type: Object,
			default: null,
		},
	},
	data() {
		return {
			options: {
				responsive: true,
				maintainAspectRatio: false,
				scales: {
					yAxes: [
						{
							ticks: {
								beginAtZero: true,
							},
						},
					],
				},
				legend: {
					align: 'start',
					position: 'bottom',
				},
				tooltips: {
					enabled: false,
					custom: function (tooltipModel) {
						var tooltipEl = document.getElementById('chartjs-tooltip');
						if (!tooltipEl) {
							tooltipEl = document.createElement('div');
							tooltipEl.id = 'chartjs-tooltip';
							tooltipEl.innerHTML = '<table></table>';
							document.body.appendChild(tooltipEl);
						}
						if (tooltipModel.opacity === 0) {
							tooltipEl.style.opacity = 0;
							return;
						}

						tooltipEl.classList.remove('above', 'below', 'no-transform');
						if (tooltipModel.yAlign) {
							tooltipEl.classList.add(tooltipModel.yAlign);
						} else {
							tooltipEl.classList.add('no-transform');
						}

						function getBody(bodyItem) {
							return bodyItem.lines;
						}

						if (tooltipModel.body) {
							var titleLines = tooltipModel.title || [];
							var bodyLines = tooltipModel.body.map(getBody);
							var innerHtml = '<thead>';
							titleLines.forEach(function (title) {
								innerHtml += '<tr><th>' + title + '</th></tr>';
							});
							innerHtml += '</thead><tbody>';

							bodyLines.forEach(function (body, i) {
								var colors = tooltipModel.labelColors[i];
								var style = 'background:' + colors.backgroundColor;
								style += '; border-color:' + colors.borderColor;
								style += '; border-width: 2px';
								var span = '<span style="' + style + '"></span>';
								innerHtml += '<tr><td>' + span + body + '</td></tr>';
							});
							innerHtml += '</tbody>';

							var tableRoot = tooltipEl.querySelector('table');
							tableRoot.innerHTML = innerHtml;
						}
						var position = this._chart.canvas.getBoundingClientRect();

						tooltipEl.style.opacity = 1;
						tooltipEl.style.position = 'absolute';
						tooltipEl.style.left =
							position.left + window.pageXOffset + tooltipModel.caretX + 'px';
						tooltipEl.style.top =
							position.top + window.pageYOffset + tooltipModel.caretY + 'px';
						tooltipEl.style.fontFamily = tooltipModel._bodyFontFamily;
						tooltipEl.style.fontSize = tooltipModel.bodyFontSize + 'px';
						tooltipEl.style.fontStyle = tooltipModel._bodyFontStyle;
						tooltipEl.style.padding =
							tooltipModel.yPadding + 'px ' + tooltipModel.xPadding + 'px';
						tooltipEl.style.pointerEvents = 'none';
						tooltipEl.style.backgroundColor = '#FFF';
						tooltipEl.style.border = '1px solid #000';
						tooltipEl.style.boxShadow = '10px 10px 22px 0px rgba(0,0,0,0.75)';
					},
				},
			},
		};
	},
	mounted() {
		this.chartdata.datasets = Object.values(this.chartdata.datasets);
		this.setChartLimits();
		this.renderChart(this.chartdata, this.options);
	},
	methods: {
		setChartLimits() {
			/* this doesn't work correctly */
			if (this.chartdata.datasets[0].min && this.chartdata.datasets[0].max) {
				this.options.scales.yAxes[0]['ticks'].min = parseInt(this.chartdata.datasets[0].min);
				this.options.scales.yAxes[0]['ticks'].max = parseInt(this.chartdata.datasets[0].max);
			}
		},
	},
	watch: {
		chartdata(val) {
			this.chartdata.datasets = Object.values(val.datasets);
			this.renderChart(this.chartdata, this.options);
		},
	},
};
</script>
